import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const WettbewerberPreisServiceConfig = {
  name: "WettbewerberPreis",
  annotations: []
} as ServiceConfig;